import { render, staticRenderFns } from "./CollectionCarousel.vue?vue&type=template&id=1584bad4&scoped=true&lang=pug"
import script from "./CollectionCarousel.vue?vue&type=script&lang=js"
export * from "./CollectionCarousel.vue?vue&type=script&lang=js"
import style0 from "./CollectionCarousel.vue?vue&type=style&index=0&id=1584bad4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1584bad4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1584bad4')) {
      api.createRecord('1584bad4', component.options)
    } else {
      api.reload('1584bad4', component.options)
    }
    module.hot.accept("./CollectionCarousel.vue?vue&type=template&id=1584bad4&scoped=true&lang=pug", function () {
      api.rerender('1584bad4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/collection/CollectionCarousel.vue"
export default component.exports